const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

export const paymentApi = {
  // Capture PayPal order
  async captureOrder(orderId, token) {
    try {
      const headers = {
        'Content-Type': 'application/json'
      }
      if (token) {
        headers['Authorization'] = `Bearer ${token}`
      }

      const response = await fetch(`${API_BASE_URL}/capture-order`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          orderId: orderId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error capturing order:', error);
      throw error;
    }
  },

  // Get payment status
  async getPaymentStatus(paymentId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/payment-status/${paymentId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error getting payment status:', error);
      throw error;
    }
  }
};


